// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__qY8iQ","logo--header":"Logo_logo--header__QxTLM","logo--footer":"Logo_logo--footer__Ldy6Z"};